import React, { useState } from 'react';
import axios from 'axios'
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    NavLink,
    Alert
} from 'reactstrap'
import { Redirect } from 'react-router-dom'
import { useEffect } from 'react';
import { tokenConfig } from '../../utils/apiConfig';


const UpdateDetails = props => {

    const {
        modal, setModal, userDetails, setUserDetails
    } = props
    const { user } = userDetails
    const [redirect, setRedirect] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [dob, setDob] = useState(null)
    const [validId, setValidId] = useState(null)
    const [phoneNumber, setPhoneNumber] = useState(null)
    const [name, setName] = useState(null)

    useEffect(() => {
        if (user) {
            user.dob && setDob(user.dob)
            user.validId && setValidId(user.validId)
            user.phoneNumber && setPhoneNumber(user.phoneNumber)
            user.name && setName(user.name)
        }
    }, [user])

    // Function to open and close login modal
    const toggle = () => {
        setModal(!modal)
    }

    // Login Function
    const updateUser = async e => {
        e.preventDefault()

        try {
            const { data } = await axios.patch(`/api/auth`, { _id: user._id, dob, validId, phoneNumber, name }, tokenConfig())
            setUserDetails({ ...userDetails, user: data })
            toggle()
        } catch (err) {
            setErrorMessage(err.message)
        }
    }


    return (
        <div>
            <Modal
                isOpen={modal}
                toggle={toggle}
            >
                <ModalHeader
                    toggle={toggle}
                >
                    Profile Details
                </ModalHeader>
                <ModalBody>
                    {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                    <Form onSubmit={updateUser}>
                        <FormGroup>
                            <Label>Full Name</Label>
                            <Input
                                type="text"
                                defaultValue={name}
                                placeholder="Full Name as per ID"
                                onChange={e => setName(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Phone Number</Label>
                            <Input
                                type="text"
                                defaultValue={phoneNumber}
                                placeholder="eg. +60123456789"
                                onChange={e => setPhoneNumber(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>IC/Passport</Label>
                            <Input
                                type="text"
                                defaultValue={validId}
                                placeholder="Valid ID required"
                                onChange={e => setValidId(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Date of Birth</Label>
                            <Input
                                type="date"
                                defaultValue={dob}
                                onChange={e => setDob(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <Button
                            color="dark"
                            style={{ marginTop: "2rem" }}
                            block
                        >
                            Update Details
                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default UpdateDetails